module.exports = __webpack_public_path__ + "static/media/girl-3.c3dd3de8.svg";